// frontend/src/pages/itemSetupLinks.js
//
// Where a drill-through into the Items grid goes. One home for the URL shape,
// so the producer (Data Health's "Edit item") and ItemSetup's route param
// can't drift apart. Extracted from the page so the URL can be pinned by a
// unit test without rendering an AG Grid.
//
// The item code rides a route SEGMENT, not a query param: tabs are keyed by
// pathname, so `/item-setup?item_code=X` matches no registered route and
// renders the tab shell's "page not found" (the same reason the Supplier
// catalog deep link spells its item as `/suppliers/:id/catalog/:itemCode?`).
// The segment is encoded because real codes carry spaces and slashes.

// The Items grid filtered to one item, named by its item_code. The page
// filters by the code at once and shows the item's own label in the search box
// (features/item-filter/useItemFilter, seed).
export const itemsForItemPath = (itemCode) =>
  `/item-setup/item/${encodeURIComponent(itemCode)}`;
